// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"E_TheComp__gu7No"};